import { render, staticRenderFns } from "./atcCategory.vue?vue&type=template&id=6d7d991e&"
import script from "./atcCategory.vue?vue&type=script&lang=ts&"
export * from "./atcCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports